import { render, staticRenderFns } from "./OutputEthicsAndDissemination.vue?vue&type=template&id=05e1e504&"
import script from "./OutputEthicsAndDissemination.vue?vue&type=script&lang=js&"
export * from "./OutputEthicsAndDissemination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports